import { render, staticRenderFns } from "./DevBpbjLeadoutRecordList.vue?vue&type=template&id=28d9fc53&scoped=true&"
import script from "./DevBpbjLeadoutRecordList.vue?vue&type=script&lang=js&"
export * from "./DevBpbjLeadoutRecordList.vue?vue&type=script&lang=js&"
import style0 from "./DevBpbjLeadoutRecordList.vue?vue&type=style&index=0&id=28d9fc53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d9fc53",
  null
  
)

export default component.exports